import {
  forwardRef,
  type ComponentPropsWithoutRef,
  type PropsWithChildren,
} from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export const ModalPanel = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ComponentPropsWithoutRef<"div">>
>(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      className={twMerge(
        "bg-v2-primary border border-v2-tertiary text-v2-primary rounded p-6",
        className,
      )}
    >
      {children}
    </div>
  );
});

export const ModalPanelContent = ({
  children,
  footer,
}: PropsWithChildren<{
  footer?: React.ReactNode;
}>) => {
  return (
    <div
      className={twMerge("grid h-full", !!footer && "grid-rows-[auto_60px]")}
    >
      <div className={clsx("overflow-auto px-5 py-6", { "h-full": !!footer })}>
        {children}
      </div>
      {footer}
    </div>
  );
};
